import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["text", "loading"]

  async load(event) {
    // The element is a real `<a href="?page=N">` for crawlers. Let modified
    // clicks (new tab, etc.) follow it; plain clicks load in place.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return
    event.preventDefault()

    this.textTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")

    const response = await fetch(this.urlValue, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })

    if (response.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    }
  }
}
